import Chart from "~/components/analytics/shared/Chart";
import { Metrics, ChartData } from "~/components/analytics/shared/type";
import { ChartDataset, ChartOptions as ChartJSOptions } from "chart.js";

type Props = {
  metric: Metrics["metric"];
  chartType: Metrics["chartType"];
  series: ChartData;
};

interface ChartOptions {
  options: ChartJSOptions;
  data: {
    datasets: Omit<ChartDataset<"bar" | "line">, "data">[];
  };
}

const chartOptions = (metric: Props["metric"]) => {
  const options: ChartOptions = {
    data: {
      datasets: [
        {
          label: metric,
          // @ts-expect-error - border radius is only available in bar chart
          borderRadius: 2,
        },
      ],
    },
    options: {
      scales: {
        // eslint-disable-next-line id-length
        x: {
          grid: {
            display: false,
          },
          ticks: {
            display: false,
          },
        },
        // eslint-disable-next-line id-length
        y: {
          beginAtZero: true,
          border: {
            display: false,
          },
          grid: {
            display: false,
          },
          ticks: {
            display: false,
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      layout: { padding: 1 },
      events: [], // disable all hover/click events for mini chart
    },
  };
  return options;
};

// A wrapper to pass through options to the non-interactive chart
const MiniChart = ({ metric, chartType, series }: Props) => (
  <Chart
    height={50}
    width={200}
    metric={metric}
    series={series}
    options={chartOptions(metric)}
    chartType={chartType}
  />
);

export default MiniChart;
